import script from "./CsForecast.vue?vue&type=script&setup=true&lang=js"
export * from "./CsForecast.vue?vue&type=script&setup=true&lang=js"

import "./CsForecast.vue?vue&type=style&index=0&id=06d029b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d029b0"]])

export default __exports__